<script setup lang="ts">
/**
 * The routed screen; or a notice when the org's module is switched off, or
 * "access denied" when the account lacks the permission: an empty page would
 * pass for a failure.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { can, screenOn } from '@/lib/auth'
import ForbiddenPage from './pages/ForbiddenPage.vue'
import ModuleOffPage from './pages/ModuleOffPage.vue'
import { vPageIn } from './pageIn'

const route = useRoute()
const moduleOn = computed(() => screenOn(route.path))
const allowed = computed(() => !route.meta.perm || can(route.meta.perm))
</script>

<template>
  <!-- Each new screen rises in (a query change, a tab of the same screen, does not). -->
  <div v-page-in="route.path" class="min-w-0">
    <ModuleOffPage v-if="!moduleOn" />
    <RouterView v-else-if="allowed" />
    <ForbiddenPage v-else :perm="route.meta.perm!" />
  </div>
</template>
